module.exports = __webpack_public_path__ + "static/media/woman_05.8d362744.png";